import {
  ENUM_COKITCHEN_TEAM,
  ENUM_CS_ROLE,
  ENUM_KITCHEN_ROLE,
  ENUM_LOGISTICS_ROLE,
  ENUM_ROLE,
  ENUM_SECURITY_ROLE
} from '@cokitchen/cokitchen-auth';
import {
  CS_ROUTE_KEYS,
  KITCHEN_ROUTE_KEYS,
  LOGISTICS_ROUTE_KEYS,
  SECURITY_ROUTE_KEYS,
  STORAGE_KEYS
} from './constants';
import { PANEL_ROLES } from './enum';
import { ROLE_ATTR } from 'router/types';

export const CS_TEAM_ROLES: Record<ENUM_CS_ROLE, ROLE_ATTR> = {
  CUSTOMER_SERVICE: {
    name: 'customer-service',
    baseRoute: CS_ROUTE_KEYS.PENDING_TASKS,
    routes: Object.values(CS_ROUTE_KEYS)
  },
  CUSTOMER_SERVICE_ADMIN: {
    name: 'customer-service-admin',
    baseRoute: CS_ROUTE_KEYS.PENDING_TASKS,
    routes: Object.values(CS_ROUTE_KEYS)
  },
  ADMIN: {
    name: 'customer-service-admin',
    baseRoute: CS_ROUTE_KEYS.PENDING_TASKS,
    routes: Object.values(CS_ROUTE_KEYS)
  },
  SUPER_ADMIN: {
    name: 'customer-service-admin',
    baseRoute: CS_ROUTE_KEYS.PENDING_TASKS,
    routes: Object.values(CS_ROUTE_KEYS)
  },
  DEVELOPER: {
    name: 'customer-service-admin',
    baseRoute: CS_ROUTE_KEYS.PENDING_TASKS,
    routes: Object.values(CS_ROUTE_KEYS)
  },
  CUSTOMER_SERVICE_LEAD: {
    name: 'customer-service-lead',
    baseRoute: CS_ROUTE_KEYS.PENDING_TASKS,
    routes: Object.values(CS_ROUTE_KEYS)
  },
  CUSTOMER_SERVICE_INBOUND: {
    name: 'customer-service-lead',
    baseRoute: CS_ROUTE_KEYS.PENDING_TASKS,
    routes: Object.values(CS_ROUTE_KEYS)
  },
  CUSTOMER_SERVICE_OUTBOUND: {
    name: 'customer-service-lead',
    baseRoute: CS_ROUTE_KEYS.PENDING_TASKS,
    routes: Object.values(CS_ROUTE_KEYS)
  },
  FRONT_DESK: {
    name: 'front-desk',
    baseRoute: CS_ROUTE_KEYS.PENDING_TASKS,
    routes: Object.values(CS_ROUTE_KEYS)
  }
};

const KITCHEN_TEAM_ROLES: Record<ENUM_KITCHEN_ROLE.KITCHEN_ADMIN, ROLE_ATTR> = {
  KITCHEN_ADMIN: {
    name: 'kitchen-admin',
    baseRoute: KITCHEN_ROUTE_KEYS.LIVE_TRIPS,
    routes: Object.values(KITCHEN_ROUTE_KEYS)
  }
};

const LOGISTICS_TEAM_ROLES: Record<ENUM_LOGISTICS_ROLE, ROLE_ATTR> = {
  LOGISTICS_SUPER_ADMIN: {
    name: 'lg-super-admin',
    baseRoute: LOGISTICS_ROUTE_KEYS.OVERVIEW,
    routes: Object.values(LOGISTICS_ROUTE_KEYS)
  },
  SUPER_ADMIN: {
    name: 'lg-super-admin',
    baseRoute: LOGISTICS_ROUTE_KEYS.OVERVIEW,
    routes: Object.values(LOGISTICS_ROUTE_KEYS)
  },
  ADMIN: {
    name: 'lg-super-admin',
    baseRoute: LOGISTICS_ROUTE_KEYS.OVERVIEW,
    routes: Object.values(LOGISTICS_ROUTE_KEYS)
  },
  DEVELOPER: {
    name: 'lg-super-admin',
    baseRoute: LOGISTICS_ROUTE_KEYS.OVERVIEW,
    routes: Object.values(LOGISTICS_ROUTE_KEYS)
  },
  LOGISTICS_ADMIN: {
    name: 'lg-admin',
    baseRoute: LOGISTICS_ROUTE_KEYS.OVERVIEW,
    routes: Object.values(LOGISTICS_ROUTE_KEYS).filter((t) => t !== '/settings')
  }
};

const SECURITY_TEAM_ROLES: Record<ENUM_SECURITY_ROLE, ROLE_ATTR> = {
  SECURITY: {
    name: 'security',
    baseRoute: SECURITY_ROUTE_KEYS.SECURITY,
    routes: Object.values(SECURITY_ROUTE_KEYS)
  },
  SUPER_ADMIN: {
    name: 'security',
    baseRoute: SECURITY_ROUTE_KEYS.SECURITY,
    routes: Object.values(SECURITY_ROUTE_KEYS)
  },
  ADMIN: {
    name: 'security',
    baseRoute: SECURITY_ROUTE_KEYS.SECURITY,
    routes: Object.values(SECURITY_ROUTE_KEYS)
  },
  DEVELOPER: {
    name: 'security',
    baseRoute: SECURITY_ROUTE_KEYS.SECURITY,
    routes: Object.values(SECURITY_ROUTE_KEYS)
  }
};

export const getCokitchenTeam = () => {
  const role = localStorage.getItem(STORAGE_KEYS.ROLE) as PANEL_ROLES;
  const allRoles: Record<ENUM_COKITCHEN_TEAM, PANEL_ROLES[]> = {
    cs: Object.values(ENUM_CS_ROLE),
    logistics: Object.values(ENUM_LOGISTICS_ROLE),
    kitchen: Object.values(ENUM_KITCHEN_ROLE),
    security: Object.values(ENUM_SECURITY_ROLE)
  };
  for (let i = 0; i < Object.entries(allRoles).length; i++) {
    const [key, values] = Object.entries(allRoles)[i];
    const roleValue = values.find((v) => v === role);
    if (roleValue) {
      return key as ENUM_COKITCHEN_TEAM;
    }
  }
};

export const getCurrentTeam = (): ENUM_COKITCHEN_TEAM | undefined => {
  const team = getCokitchenTeam();
  if (!team) return;
  return team;
};

export const getTeamRoles = (): Record<ENUM_ROLE, ROLE_ATTR> | undefined => {
  const mapping: Record<ENUM_COKITCHEN_TEAM, any> = {
    cs: CS_TEAM_ROLES,
    kitchen: KITCHEN_TEAM_ROLES,
    logistics: LOGISTICS_TEAM_ROLES,
    security: SECURITY_TEAM_ROLES
  };
  const currentTeam = getCurrentTeam();
  if (!currentTeam) return;
  return mapping[currentTeam];
};

const HEADER_LINK_MAP: Record<
  ENUM_COKITCHEN_TEAM,
  { name: string; path: string; options?: { name: string; path: string }[] }[]
> = {
  cs: [
    {
      name: 'Pending tasks',
      path: CS_ROUTE_KEYS.PENDING_TASKS
    },
    {
      name: 'Live Trips',
      path: CS_ROUTE_KEYS.LIVE_TRIPS
    },
    {
      name: 'Task History',
      path: CS_ROUTE_KEYS.TASK_HISTORY
    },

    {
      name: 'Recalled Orders',
      path: CS_ROUTE_KEYS.RECALLED_ORDERS
    },
    {
      name: 'Search',
      path: CS_ROUTE_KEYS.SEARCH
    },
    {
      name: 'Reviews',
      path: CS_ROUTE_KEYS.REVIEWS
    }
  ],
  logistics: [
    {
      name: 'Overview',
      path: LOGISTICS_ROUTE_KEYS.OVERVIEW
    },
    {
      name: 'Live Trips',
      path: LOGISTICS_ROUTE_KEYS.LIVE_TRIPS
    },
    {
      name: 'Partners',
      path: LOGISTICS_ROUTE_KEYS.PARTNERS
    },
    {
      name: 'Recalled Orders',
      path: LOGISTICS_ROUTE_KEYS.RECALLED_ORDERS
    },
    {
      name: 'Search',
      path: LOGISTICS_ROUTE_KEYS.SEARCH
    },
    {
      name: 'Scheduled',
      path: LOGISTICS_ROUTE_KEYS.SCHEDULED
    }
  ],
  kitchen: [
    {
      name: 'Live Trips',
      path: KITCHEN_ROUTE_KEYS.LIVE_TRIPS
    },
    {
      name: 'Search',
      path: KITCHEN_ROUTE_KEYS.SEARCH
    },
    {
      name: 'Inventory',
      path: KITCHEN_ROUTE_KEYS.INVENTORY,
      options: [
        { name: 'Inventory management', path: KITCHEN_ROUTE_KEYS.INVENTORY },
        { name: 'Meal production tracker', path: KITCHEN_ROUTE_KEYS.MEAL_PRODUCTION_TRACKER }
      ]
    }
  ],
  security: []
};

export const getHeaderLinks = () => {
  const team = getCurrentTeam();

  if (!team) return [];
  return HEADER_LINK_MAP[team];
};

const getLogisticsRoutes = (role: PANEL_ROLES) => {
  role = role as ENUM_LOGISTICS_ROLE;
  return LOGISTICS_TEAM_ROLES[role];
};
const getKitchenRoutes = (role: PANEL_ROLES) => {
  role = role as ENUM_KITCHEN_ROLE.KITCHEN_ADMIN;
  return KITCHEN_TEAM_ROLES[role];
};
const getCsRoutes = (role: PANEL_ROLES) => {
  role = role as ENUM_CS_ROLE;
  return CS_TEAM_ROLES[role];
};
const getSecurityRoutes = (role: PANEL_ROLES) => {
  role = role as ENUM_SECURITY_ROLE;
  return SECURITY_TEAM_ROLES[role];
};

export const getRoleRoutes = () => {
  const role = localStorage.getItem(STORAGE_KEYS.ROLE) as PANEL_ROLES;
  const teamMapping: Record<ENUM_COKITCHEN_TEAM, (role: PANEL_ROLES) => ROLE_ATTR> = {
    cs: getCsRoutes,
    logistics: getLogisticsRoutes,
    kitchen: getKitchenRoutes,
    security: getSecurityRoutes
  };
  const currentTeam = getCurrentTeam();
  if (!currentTeam) return [];
  return teamMapping[currentTeam](role)?.routes;
};

export const getInitialRoute = () => {
  const role = localStorage.getItem(STORAGE_KEYS.ROLE) as PANEL_ROLES;
  const currentTeam = getCurrentTeam();
  if (!currentTeam) return '';
  const teamMapping: Record<ENUM_COKITCHEN_TEAM, (role: PANEL_ROLES) => ROLE_ATTR> = {
    cs: getCsRoutes,
    logistics: getLogisticsRoutes,
    kitchen: getKitchenRoutes,
    security: getSecurityRoutes
  };
  return teamMapping[currentTeam](role)?.baseRoute;
};
